export default {
  name: "Appendix A - Multiple Worksites",
  pageAlert: {
    widget: "pageAlert",
    alerts: [
      {
        title: "Information Required",
        description:
          "Please specify in Field F.c.1 whether work is being performed at multiple worksites.",
        type: "info",
        isVisible: {
          when: "jobMultiplesites",
          is: "untouched",
          operator: "untouched",
        },
      },
      {
        title: "Section Complete",
        description: `Because you indicated that work is only being performed at one worksite (per Field F.c.1), no Appendix A is necessary for this application.`,
        type: "success",
        isVisible: {
          when: "jobMultiplesites",
          is: ["NO"],
          operator: "compareMultiFieldValuesAND_ORInArray",
        },
      },
    ],
  },
  pageInfo: {
    text: `<b>Important Note:</b> Employers are required to complete Appendix A when supplying information about additional worksites. 
    Submission of additional worksite information in any other form or format will not be accepted. Only worksites entered on the 
    Form ETA-9142 and Appendix A will be used in the processing of the employer’s request for temporary labor certification.`,
    coloring: `grey`,
    isVisible: {
      when: "jobMultiplesites",
      is: ["YES"],
      operator: "compareMultiFieldValuesAND_ORInArray",
    },
  },
  sections: [
    {
      code: "Appendix A",
      name: "Additional Places of Employment",
      sectionInfo: {
        text: `Complete Items 1 through 6 for each worksite location where the services or labor is expected to be performed, 
        as applicable. If the employer intends for the workers sought to perform labor or services at more than ten (10) worksite 
        locations, the employer must complete as many additional worksite location entries on the Appendix A as are necessary 
        to list all intended worksite locations for this application.`,
        coloring: "grey",
      },
      isVisible: {
        when: "jobMultiplesites",
        is: ["YES"],
        operator: "compareMultiFieldValuesAND_ORInArray",
      },
      fields: [
        {
          machine_name: "employmentLocations",
          widget: "tableLoader",
          widgetConfig: {
            fromField: "employmentLocationWorksites",
            toField: "employmentLocations",
            buttonText: "Add Worksites",
          },
        },
        {
          code: "Appendix A",
          machine_name: "employmentLocations",
          widget: "tableEditor",
          validate: ["tableRequired", "tableIncomplete"],
          fromFields: [
            "tempneedWkrPos",
            "tempneedStart",
            "tempneedEnd",
            "_blsCounties",
          ],
        },
      ],
    },
  ],
};
